
const Configuration = {
    BASEURL: process.env.REACT_APP_SERVER_BASE_URL,
    LANDING_SCREEN_SPLINEURL: process.env.REACT_APP_LANDING_SPLINE_URL,
    ROBOT_SPLINEURL: process.env.REACT_APP_ROBOT_SPLINE_URL,
    LINKEDINURL: process.env.REACT_APP_IINVSYS_LINKED_IN_URL,
    FACEBOOKURL: "https://www.facebook.com/iinvsys",
    INSTAGRAMURL: "https://www.instagram.com/iinvsys/",
    YOUTUBEURL: "https://www.youtube.com/channel/UClvD3P0gf9IZZDPgLc2UVUg",
    THREADSURL: "https://www.threads.com/@iinvsys",
    MAILURL: process.env.REACT_APP_IINVSYS_MAIL_URL,
    CHENNAI_LOCATION_URL: process.env.REACT_APP_IINVSYS_CHENNAI_LOCATION || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.2604893129565!2d80.27157567484227!3d13.019076837300698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267df28d0ff05%3A0xcdf179fd527a3454!2sTVH%20Belicia%20Towers%2C%20MRC%20Nagar%201st%20Lane%2C%20MRC%20Nagar%2C%20Raja%20Annamalaipuram%2C%20Chennai%2C%20Tamil%20Nadu%20600028!5e0!3m2!1sen!2sin!4v1764914193164!5m2!1sen!2sin",
    PUDUCHERRY_LOCATION_URL: process.env.REACT_APP_IINVSYS_PUDUCHERRY_LOCATION || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3903.5085682178287!2d79.80571647482338!3d11.939249688289252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a53619820bd88c5%3A0x7a70aefbe506c090!2sIINVSYS%20Pvt.%20Ltd!5e0!3m2!1sen!2sin!4v1764914529324!5m2!1sen!2sin",
    PUDUCHERRY_PRODUCTION_OFFICE_LOCATION_URL: "https://maps.google.com/maps?q=11.946229,79.805809&t=&z=17&ie=UTF8&iwloc=&output=embed",
    SEDARAPET_LOCATION_URL: "https://maps.google.com/maps?q=13+Sedarapet+Main+Road%2C+Sedarapet%2C+Tamil+Nadu+605111&t=&z=16&ie=UTF8&iwloc=&output=embed",
    MUMBAI_LOCATION_URL: "https://maps.google.com/maps?q=19.137805,72.832513&t=&z=17&ie=UTF8&iwloc=&output=embed",
    KARWAR_LOCATION_URL: process.env.REACT_APP_IINVSYS_KARWAR_LOCATION,
    PHONE_NUMBER: '',
    MAIN_ADDRESS: '1st Floor, JK Towers, 100 Feet Road, Puducherry - 605013',
    LINKEDIN_TEXT: "Linkedin/iinvsys",
    OFFICE_TIMINGS: "9.00 - 18.30",
    API_TIMEOUT: 10000,
    API_HEADER: {
        "Content-Type": "application/json",
    },

    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    S3_URL: process.env.REACT_APP_S3_BASE_URL

}

export default Configuration;